import { isInIframe } from '../utils/iframe';

/**
 * useIsEmbedded — Detects whether the app is rendered inside an iframe.
 *
 * When embedded, the UI strips all chrome (sidebar, top bar, language
 * selector, footer) and renders only the core flow content.
 *
 * Embedded mode takes priority over mobile/desktop layout selection.
 */
export function useIsEmbedded(): boolean {
  return isInIframe();
}
